import React from 'react';
import T from 'prop-types';

import Modal from '../../../Modal';

const verticalLayoutColumns = [
  { dataField: 'app_id', text: 'App ID' },
  { dataField: 'app_name', text: 'App Name' },
  { dataField: 'publisher', text: 'Publisher' },
  { dataField: 'country', text: 'Country' },
  { dataField: 'company', text: 'Company' },
  { dataField: 'figi', text: 'FIGI' },
  { dataField: 'ticker', text: 'Ticker' },
  { dataField: 'date', text: 'Date' },
  { dataField: 'downloads', text: 'Downloads' },
];

const verticalLayoutRows = [
  {
    app_id: '947984433',
    app_name: 'Amazon Fire TV',
    publisher: 'AMZN Mobi..',
    country: 'US',
    company: 'Amazon',
    figi: 'BBG000BVPV84',
    ticker: 'NASDAQ:AMZN',
    date: '03/01/2010',
    downloads: '157557',
  },
  {
    app_id: 'com.amazon.sto..',
    app_name: 'Amazon Fire TV',
    publisher: 'Amazon Mo..',
    country: 'US',
    company: 'Amazon',
    figi: 'BBG000BVPV84',
    ticker: 'NASDAQ:AMZN',
    date: '03/01/2010',
    downloads: '165952',
  },
  {
    app_id: '342792525',
    app_name: 'IMDb Movies &..',
    publisher: 'IMDb',
    country: 'US',
    company: 'Amazon',
    figi: 'BBG000BVPV84',
    ticker: 'NASDAQ:AMZN',
    date: '03/01/2010',
    downloads: '93127',
  },
  {
    app_id: 'com.imdb.mobile',
    app_name: 'IMDb Movies &..',
    publisher: 'IMDb',
    country: 'US',
    company: 'Amazon',
    figi: 'BBG000BVPV84',
    ticker: 'NASDAQ:AMZN',
    date: '03/01/2010',
    downloads: '90542',
  },
  {
    app_id: '1386412985',
    app_name: 'WhatsApp Busi..',
    publisher: 'WhatsApp In..',
    country: 'US',
    company: 'Facebook',
    figi: 'BBG000MM2P62',
    ticker: 'NASDAQ:FB',
    date: '03/01/2010',
    downloads: '51543',
  },
  {
    app_id: 'com.whatsapp.w..',
    app_name: 'WhatsApp Busi..',
    publisher: 'WhatsApp In..',
    country: 'US',
    company: 'Facebook',
    figi: 'BBG000MM2P62',
    ticker: 'NASDAQ:FB',
    date: '03/01/2010',
    downloads: '67364',
  },
];

const horizontalLayoutColumns = [
  { dataField: 'entity_name', text: 'Entity Name' },
  { dataField: 'entity_id', text: 'Entity Id' },
  { dataField: 'store', text: 'Store' },
  { dataField: 'publisher_name', text: 'Publisher Name' },
  { dataField: 'price', text: 'Price' },
  { dataField: 'date_1', text: '03/01/20' },
  { dataField: 'date_2', text: '03/02/20' },
  { dataField: 'date_3', text: '03/03/20' },
];

const horizontalLayoutRows = [
  {
    entity_name: 'Amazon (Company)',
    entity_id: '8080758295',
    store: 'Unified',
    publisher_name: '',
    price: '',
    date_1: '494516',
    date_2: '494392',
    date_3: '490462',
  },
  {
    entity_name: 'Facebook (Company)',
    entity_id: '8080523538',
    store: 'Unified',
    publisher_name: '',
    price: '',
    date_1: '759453',
    date_2: '690666',
    date_3: '703127',
  },
];

const SimpleTable = ({ columns, rows }) => {
  const thColumns = () => columns.map(({ text, dataField }) => (
    <th key={dataField} className="text-truncate">{text}</th>
  ));

  const tableRows = () => rows.map((row, i) => {
    const tds = columns.map(({ dataField }) => <td key={dataField}>{row[dataField]}</td>);
    // eslint-disable-next-line react/no-array-index-key
    return <tr key={i}>{tds}</tr>;
  });

  return (
    <table className="table table-grey-minimal table-xl">
      <thead className="thead-gray">
        <tr>{thColumns()}</tr>
      </thead>
      <tbody className="">
        {tableRows()}
      </tbody>
    </table>
  );
};

SimpleTable.propTypes = {
  columns: T.arrayOf(T.object).isRequired,
  rows: T.arrayOf(T.object).isRequired,
};

const HorizontalDataLayout = () => (
  <div>
    <h2 className="text-center text-20 text-black"><span className="text-bold">Example data schema</span> - Columns</h2>
    <p className="text-center text-black">(example shows company level aggregation unified across stores)</p>
    <p className="mb-xs text-black">Metric: Downloads</p>
    <SimpleTable
      columns={horizontalLayoutColumns}
      rows={horizontalLayoutRows}
    />
  </div>
);

const VerticalDataLayout = () => (
  <div>
    <h2 className="text-center text-20 text-black"><span className="text-bold">Example data schema</span> - Rows</h2>
    <p className="text-center mb-lg text-black">(example shows app level aggregation broken down by store)</p>
    <SimpleTable
      columns={verticalLayoutColumns}
      rows={verticalLayoutRows}
    />
  </div>
);

const DataLayoutModal = ({
  open,
  layout,
  onClose,
}) => (
  <Modal
    size="xl"
    open={open}
    modalClassName="data-layout-modal"
    shouldCloseOnOverlayClick
    closeButtonIconClass="hicon-close-2 text-xs"
    onClose={onClose}
  >
    {layout === 'horizontal' && <HorizontalDataLayout />}
    {layout === 'vertical' && <VerticalDataLayout />}
  </Modal>
);

DataLayoutModal.propTypes = {
  open: T.bool.isRequired,
  layout: T.oneOf(['horizontal', 'vertical']),
  onClose: T.func.isRequired,
};

export default DataLayoutModal;
